import { FC } from "react";

import { faMap } from "@fortawesome/free-regular-svg-icons";
import orderOptimizerTranslationsHelper from "../../../../../../../../languages/order-optimizer-translations.helper";
import TableLinkButtonComponent from "../../../../../../../../common/components/table/button/link/table-link-button.component";
import {
  OrderOptimizerRailyDetailsItemDriver,
  OrderOptimizerRailyDetailsItemStepsOrders,
} from "../../../../common/types/order-optimizer-raily-details-item";
import orderOptimizerRailyDetailsHelper from "../../../../order-optimizer-raily-details.helper";

type OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps =
  {
    driver: OrderOptimizerRailyDetailsItemDriver | null;
    step: OrderOptimizerRailyDetailsItemStepsOrders;
  };

const OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryProps
> = (props) => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyDetailsTranslations().table
      .centerTables;

  const totalDriverTime = props.step.totalTime;
  const totalHaltingTime = props.step.haltingTime;
  const totalDistance = props.step.distance;
  const lastPoint = props.step.points[props.step.points.length - 1];

  return (
    <div className="content">
      <div className="human_id" />
      <div className="address" title={translations.summaryLabel}>
        {translations.summaryLabel}
      </div>
      <div className="driver_time">
        {orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(totalDriverTime)}
      </div>
      <div
        className={`driver_halting_time ${totalHaltingTime < 0 ? "time_delayed" : ""}`}
      >
        {orderOptimizerRailyDetailsHelper.getTimeDeltaLabel(totalHaltingTime)}
      </div>
      <div className="driver_distance">
        {orderOptimizerRailyDetailsHelper.getDistanceLabel(totalDistance)}
      </div>
      <div className="actions">
        <TableLinkButtonComponent
          icon={faMap}
          openInNewTab
          to={orderOptimizerRailyDetailsHelper.getGoogleMapsUrl(
            [lastPoint],
            props.driver?.startLat,
            props.driver?.startLon,
            false,
            true,
          )}
          type="primary"
        />
      </div>
    </div>
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsCenterTablesOrdersStepSummaryComponent;
